import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { trackChartExport } from '../util/mixpanel';
import { exportCsv } from '../modules/Exporting/ExportingActions';

export default function(ComposedComponent) {
  class withChartExporting extends Component {
    static propTypes = {
      chart: PropTypes.string.isRequired,
      dates: PropTypes.object.isRequired,
      dashboard: PropTypes.object.isRequired
    };

    constructor(props) {
      super(props);

      let filename = this.getFileName(props);
      this.state = {
        chartExporting: {
          filename,
          chartOptions: {
            legend: {
              adjustChartSize: true,
              navigation: {
                enabled: false
              }
            },
            chart: {
              backgroundColor: '#fff',
              style: {
                fontFamily: 'serif'
              },
              events: {
                load: () => {
                  trackChartExport(this.props.chart);
                }
              }
            }
          },
          buttons: {
            contextButton: {
              x: props.widget ? 7 : -10,
              y: props.widget ? -10 : -14,
              symbolFill: '#767676',
              theme: {
                fill: '#fcfcfc',
                states: {
                  hover: {
                    fill: null
                  },
                  select: {
                    fill: null
                  }
                }
              },
              menuItems: [
                'downloadPNG',
                'downloadJPEG',
                'downloadPDF',
                'separator',
                {
                  text: 'Export CSV data',
                  onclick: () => {
                    if (this.props && this.props.exportCsv && this.props.chart) {
                      this.props.exportCsv(this.props.chart);
                    }
                  }
                }
              ]
            },
            allowHTML: true,
            fallbackToExportServer: false
          }
        }
      };
    }

    componentDidUpdate(prevProps) {
      if (
        this.props.dashboard &&
        (prevProps.chart != this.props.chart ||
          prevProps.dates != this.props.dates ||
          prevProps.dashboard != this.props.dashboard)
      ) {
        this.update();
      }
    }

    getFileName(props) {
      const chart = props.chart + (props.widget ? `_${props.widget}` : '');
      if (!props || !props.dashboard || !props.dashboard.name) {
        return '';
      }
      return `${props.dashboard.name.replace(' ', '-')}_${chart}_${moment(props.dates.startDate).format(
        'YYYY-M-D'
      )}_${moment(props.dates.endDate).format('YYYY-M-D')}`;
    }

    update() {
      this.setState({
        chartExporting: {
          ...this.state.chartExporting,
          filename: this.getFileName(this.props)
        }
      });
    }

    render() {
      return <ComposedComponent chartExporting={this.state.chartExporting} {...this.props} />;
    }
  }

  function mapDispatchToProps(dispatch) {
    return {
      exportCsv: (chart) => dispatch(exportCsv(chart))
    }
  }

  function mapStateToProps(state) {
    return {
      chart: state.filters.chart,
      dates: state.filters.dates,
      dashboard: state.dashboards.selected
    };
  }

  return connect(mapStateToProps, mapDispatchToProps)(withChartExporting);
}
